import React from 'react'
import { Link } from 'react-router-dom'
function Layout() {
    
  return (
    <div>
    <header className="header">
        <div className="topbar bg-theme">
            <div className="container">
            <div className="row">
                <div className="col-lg-6 col-md-5">
                <div className="leftside">
                    <ul className="custom-flex">
                    <li> <Link to="#" className="text-custom-white"><i className="fab fa-facebook-f"></i></Link> </li>
                    <li> <Link to="#" className="text-custom-white"><i className="fa-brands fa-x-twitter"></i></Link> </li>
                    <li> <Link to="#" className="text-custom-white"><i className="fab fa-instagram"></i></Link> </li>
                    <li> <Link to="#" className="text-custom-white"><i className="fab fa-linkedin"></i></Link> </li>
                    </ul>
                </div>
                </div>
                <div className="col-lg-6 col-md-7">
                <div className="rightside full-height">
                    <ul className="custom-flex full-height">
                    <li className="book-appointment"> <Link to="booking"> Booking Now </Link> </li>
                    </ul>
                </div>
                </div>
            </div>
            </div>
        </div>
        <div className="navigation-wrapper">
            <div className="container">
            <div className="row">
                <div className="col-12">
                <nav>
                    <div className="main-navigation">
                    <div className="logo"><Link to="/"><img src="/tm/react/bycycle/assets/images/logo.png" className="img-fluid" alt="logo"/> </Link> </div>
                    <div className="main-menu">
                        <ul className="custom-flex">
                        <li className="menu-item active"> <Link to="/">Home</Link> </li>
                        <li className="menu-item menu-item-has-children"> <Link to="#">Inventory</Link>
                            <ul className="submenu custom">
                            <li className="menu-item"> <Link to="/bicycle">Full Width</Link> </li>
                            <li className="menu-item"> <Link to="/bicycle-left">Left Sidebar</Link> </li>
                            <li className="menu-item"> <Link to="/bicycle-right">Right Sidebar</Link> </li>
                            <li className="menu-item"> <Link to="/bicycle-detail">Bicycle Detail</Link> </li>
                            </ul>
                        </li>
                        <li className="menu-item menu-item-has-children"> <Link to="#">Blog</Link>
                            <ul className="submenu custom">
                            <li className="menu-item"> <Link to="/blog">Blog Grid</Link> </li>
                            <li className="menu-item"> <Link to="/blog-left">Blog Left</Link> </li>
                            <li className="menu-item"> <Link to="/blog-right">Blog right</Link> </li>
                            <li className="menu-item"> <Link to="/blog-details">Blog Detail</Link> </li>
                            <li className="menu-item"> <Link to="/blog-details-left">Blog Detail Left</Link> </li>
                            <li className="menu-item"> <Link to="/blog-details-right">Blog Detail Right</Link> </li>
                            </ul>
                        </li>
                        <li className="desk-logo">
                            <div className="logo"> <Link to="/"> <img src="/tm/react/bycycle/assets/images/logo.png" className="img-fluid" alt="logo"/> </Link> </div>
                        </li>
                        <li className="menu-item"> <Link to="/about">About</Link> </li>
                        <li className="menu-item menu-item-has-children"> <Link to="#">Pages</Link>
                            <ul className="submenu custom">
                            <li className="menu-item"> <Link to="/booking">Booking</Link> </li>
                            <li className="menu-item"> <Link to="/faqs">Faq</Link> </li>
                            <li className="menu-item"> <Link to="/gallery">Gallery</Link> </li>
                            <li className="menu-item"> <Link to="/404">404</Link> </li>
                            <li className="menu-item"> <Link to="/coming-soon">Coming Soon</Link> </li>
                            </ul>
                        </li>
                        <li className="menu-item"> <Link to="/contact">Contact</Link> </li>
                        </ul>
                    </div>
                    <div className="hamburger-menu">
                        <div className="menu-btn"> <div className="hamburger"> <span></span> <span></span> <span></span> </div> </div>
                    </div>
                    </div>
                </nav>
                </div>
            </div>
            </div>
        </div>
    </header>
    </div>
  )
}

export default Layout